import { FC } from 'react';
import classNames from 'classnames';
import { Icon } from '@lambdacurry/component-library';
import * as icons from 'lib/icons';
import { Footer, FooterContent, FooterDiamond, FooterProps } from '../../Footer';

export interface GettingStartedFooterProps extends FooterProps {
  icon: keyof typeof icons;
  text: string;
}

export const GettingStartedFooter: FC<GettingStartedFooterProps> = ({ icon, text, className, ...props }) => (
  <Footer className={classNames('getting-started__footer mt-20 flex-grow-0', className)} {...props}>
    <FooterContent>
      <FooterDiamond />
      <div className="flex items-center mx-6 md:mx-10 gap-4">
        <Icon className="!w-8 !h-8" name={icon} />
        <p className="text-sm md:text-base">{text}</p>
      </div>
      <FooterDiamond />
    </FooterContent>
  </Footer>
);
